import { render, staticRenderFns } from "./SpeakersPage.vue?vue&type=template&id=4a8dd9ea&scoped=true"
import script from "./SpeakersPage.vue?vue&type=script&lang=js"
export * from "./SpeakersPage.vue?vue&type=script&lang=js"
import style0 from "./SpeakersPage.vue?vue&type=style&index=0&id=4a8dd9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8dd9ea",
  null
  
)

export default component.exports